import React from 'react';
import { useStyles } from './style';

export default function DropDownSuggestions({ displaySuggestion, suggestions, handleOptionClick }: any) {
    const classes = useStyles();
    return (
        <div style={{ position: 'relative', zIndex: 999, display: displaySuggestion ? 'block' : 'none' }}>
            <div className={classes.dropDown}>
                {suggestions?.map((suggestion: any, index: number) => (
                    <div key={index} className={classes.boxOption} onClick={() => handleOptionClick(suggestion)}>
                        <p className={classes.pageOption}>{suggestion}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
